const BASE_REM = 16;
let getRootFontSize = () => {
    const htmlElement = document.documentElement;
    const computedStyle = window.getComputedStyle(htmlElement);
    const fontSize = computedStyle.fontSize;
    return parseFloat(fontSize);
};
let convertToRelativePx = (pixels) => {
    const remValue = pixels / BASE_REM;
    const rootFontSize = getRootFontSize();
    return remValue * rootFontSize;
};
let convertToRem = (pixels) => {
    if (pixels === 0)
        return '0';
    // const rootFontSize = getRootFontSize();
    return pixels / BASE_REM + 'rem';
};
let convertToRelativeRem = (pixels) => {
    if (pixels === 0)
        return '0';
    const rootFontSize = getRootFontSize();
    return pixels / rootFontSize + 'rem';
};

/**
 * Generated bundle index. Do not edit.
 */

export { BASE_REM, convertToRelativePx, convertToRelativeRem, convertToRem, getRootFontSize };
